import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import TrustIndicators from '../components/home/TrustIndicators';
import CorporateIntro from '../components/home/CorporateIntro';
import BrandsSection from '../components/home/BrandsSection';
import FeaturedServices from '../components/home/FeaturedServices';
import FeaturedProject from '../components/home/FeaturedProject';
import SiesaAppSection from '../components/home/SiesaAppSection';
import WhyChooseUs from '../components/home/WhyChooseUs';
import SectorsSection from '../components/home/SectorsSection';
import QuoteCallToAction from '../components/ui/QuoteCallToAction';
import { organizationSchema, localBusinessSchema, jsonLd } from '../lib/seo';

export default function Home() {
  return (
    <Layout
      title="Soluciones eléctricas integrales"
      description="Diseñamos, suministramos, instalamos y mantenemos sistemas eléctricos de baja y media tensión para la industria, el comercio y proyectos residenciales en Panamá."
      seoChildren={
        <>
          <script type="application/ld+json">{jsonLd(organizationSchema())}</script>
          <script type="application/ld+json">{jsonLd(localBusinessSchema())}</script>
        </>
      }
    >
      <Hero />
      <TrustIndicators />
      <CorporateIntro />
      <BrandsSection />
      <FeaturedServices />
      <FeaturedProject />
      <SiesaAppSection />
      <WhyChooseUs />
      <SectorsSection />
      <QuoteCallToAction />
    </Layout>
  );
}
